import { CURRICULUM_TYPENAMES } from "./curriculumTypenames";

export const CONTENT_SECTION_TYPES = {
  CONTENT_SECTION: CURRICULUM_TYPENAMES.CONTENT_SECTION,
  QUIZ: CURRICULUM_TYPENAMES.QUIZ_QUESTION,
};
